export default __webpack_public_path__ + "static/media/Poster-01.b52700b9.jpg";